var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 25C15.1722 25 14.5002 24.328 14.5002 23.5C14.5002 22.672 15.1722 22 16.0002 22C16.8282 22 17.5002 22.672 17.5002 23.5C17.5002 24.328 16.8282 25 16.0002 25ZM14.8752 8H17.1252V19H14.8752V8ZM30.8512 15.449L23.8872 3.532C23.6942 3.202 23.3432 3 22.9642 3H9.03625C8.65725 3 8.30625 3.202 8.11325 3.532L1.14925 15.449C0.95025 15.789 0.95025 16.211 1.14925 16.551L8.11325 28.468C8.30625 28.798 8.65725 29 9.03625 29H22.9642C23.3432 29 23.6942 28.798 23.8872 28.468L30.8512 16.551C31.0502 16.211 31.0502 15.789 30.8512 15.449Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.50f6f356cb7f71e1969b5301fe167592.svg";
export { ForwardRef as ReactComponent };